(function () {
    'use strict';
    var m = angular.module('settings');
    m.controller('SettingsController', ["$scope", "avananUserDao", "modals", "friendlyDomainsDao", "localModuleDao", "commonDao", "sideMenuManager", "configDao", "objectTypeDao", "fileDao", "$location", "troubleshooting", "entityTypes", "$q", "fileSecurityDebugHelper", "idleManager", "modulesManager", "feature", "routeHelper", "emailReportDao", "modulesDao", "$timeout", "$cookies", "autologinHelper", "http", function ($scope, avananUserDao, modals, friendlyDomainsDao, localModuleDao, commonDao, sideMenuManager, configDao, objectTypeDao, fileDao, $location, troubleshooting, entityTypes, $q, fileSecurityDebugHelper, idleManager, modulesManager, feature, routeHelper, emailReportDao, modulesDao, $timeout, $cookies, autologinHelper, http) {
        $scope.feature = feature;
        $scope.autologinCP = autologinHelper.enabled() || $cookies.get('autologinCP');
        if ($location.search().debug === '1') {
            $scope.entityDebugEnabled = troubleshooting.entityDebugEnabled(true);
            sideMenuManager.updateMenus();
        } else {
            if ($location.search().debug === '0') {
                $scope.entityDebugEnabled = troubleshooting.entityDebugEnabled(false);
                sideMenuManager.updateMenus();
            }
            $scope.entityDebugEnabled = troubleshooting.entityDebugEnabled();
        }
        if ($location.search()['show-js-errors'] === '1') {
            localStorage.setItem('show-js-errors', '1');
        } else if ($location.search()['show-js-errors'] === '0') {
            localStorage.removeItem('show-js-errors');
        }
        $scope.changePasswordPanel = {
            title: 'Change Password',
            'class': 'light white-body white-header no-margin',
            bodyStyle: { height: '175px' }
        };
        $scope.changePasswordModel = {
            oldPassword: '',
            newPassword: '',
            repeatPassword: ''
        };
        if (feature.emailDomainsManagement && troubleshooting.entityDebugEnabled()) {
            $scope.domainsManageLink = routeHelper.getHref('email-domains');
        }
        // hide password change when unwanted:
        $scope.showPassword = feature.checkpointTheme || feature.sonicwallTheme ? false : true;
        //
        $scope.error = {};
        $scope.changePassword = function () {
            $scope.error = {};
            if (!$scope.changePasswordModel.oldPassword.length) {
                $scope.error.oldPassword = 'Password should not be empty';
                return;
            }
            if (!$scope.changePasswordModel.newPassword.length) {
                $scope.error.newPassword = 'Password should not be empty';
                return;
            }
            if ($scope.changePasswordModel.newPassword != $scope.changePasswordModel.repeatPassword) {
                $scope.error.repeatPassword = 'Passwords are not same';
                return;
            }
            avananUserDao.changePassword($scope.changePasswordModel.oldPassword, $scope.changePasswordModel.newPassword).then(function () {
                modals.alert('Password changes successfully');
            }, function (error) {
                $scope.error.oldPassword = error.data.message.replace(/\n/g, '<br />');
                $scope.error.newPassword = error.data.message.replace(/\n/g, '<br />');
            });
        };
        $scope.friendlyDomainsModel = { domains: [] };
        if (troubleshooting.entityDebugEnabled()) {
            friendlyDomainsDao.list().then(function (domains) {
                $scope.friendlyDomainsModel.domains = domains.data;
                $scope.friendlyDomainsPanel = {
                    title: 'Friendly domains',
                    'class': 'light white-body white-header no-margin',
                    bodyStyle: { height: '175px' }
                };
                $scope.saveDomains = function () {
                    friendlyDomainsDao.update($scope.friendlyDomainsModel.domains, true);
                };
            });
        }
        $scope.advancedPanel = {
            title: 'Advanced',
            'class': 'light white-body white-header no-margin',
            bodyStyle: { height: '380px' }
        };
        if (troubleshooting.entityDebugEnabled()) {
            localModuleDao.retrieve().then(function (response) {
                if (!response.data || _(response.data).isEmpty()) {
                    return;
                }
                function entityKey(module) {
                    return module + '_entity_id';
                }
                var localModules = response.data;
                $scope.updateLocalModules = function () {
                    var params = [{
                            type: 'selector',
                            id: 'module',
                            label: 'Choose module',
                            variants: _(localModules).map(function (val, key) {
                                return {
                                    id: key,
                                    label: key
                                };
                            }),
                            validation: { required: { message: 'Please select module' } }
                        }];
                    var modulesArr = [];
                    _(localModules).each(function (val, key) {
                        modulesArr.push(key);
                        params.push({
                            type: 'selector',
                            id: entityKey(key),
                            label: 'Choose entity',
                            variants: _(val.entities).map(function (info, entity_id) {
                                return {
                                    id: entity_id,
                                    label: info.label
                                };
                            }),
                            enabled: {
                                param: 'module',
                                equal: key
                            },
                            validation: { required: { message: 'Please select entity' } },
                            disabledValue: 'none'
                        });
                    });
                    params.push({
                        id: 'logfile',
                        type: 'file',
                        label: 'Choose a file',
                        validation: { required: { message: 'Please select file' } },
                        enabled: [{
                                param: 'module',
                                in: modulesArr
                            }].concat(_(localModules).map(function (val, key) {
                            return {
                                param: entityKey(key),
                                notEmpty: true
                            };
                        }))
                    });
                    modals.params([{
                            lastPage: true,
                            okButton: 'Upload',
                            params: params
                        }], 'Upload configuration file').then(function (data) {
                        localModuleDao.uploadCsv(data.module, data[entityKey(data.module)], data.logfile).then(function (response) {
                            if (response.data.success) {
                                modals.alert('Successfully uploaded', { title: 'Success' });
                            } else {
                                modals.alert('Error uploading file', { title: 'Error' });
                            }
                        }, function (error) {
                            modals.alert('Error uploading file', { title: 'Error' });
                        });
                    });
                };
            });
        }
        if (!feature.checkpointTheme) {
            $scope.manageEmailLogo = true;
        }
        if (sideMenuManager.currentUser().admin) {
            $scope.configureSaml = function () {
                return configDao.getSamlConfig().then(function (response) {
                    var conf = response.data;
                    var params = [{
                            type: 'string',
                            label: 'SAML SSO URL',
                            readOnly: true,
                            data: window.location.origin + '/auth/saml/sso',
                            copyButton: true
                        }];
                    var actions = [
                        {
                            value: 'set_url',
                            label: 'Use a metadata URL'    // }, {
                                                    //     value: 'set_from_url',
                                                    //     label: 'Get metadata from url and set as static'
                        },
                        {
                            value: 'upload',
                            label: 'Upload a metadata file'    // }, {
                                                        //     value: 'set_text',
                                                        //     label: 'Configure static metadata as text'
                        }
                    ];
                    var defaultAction;
                    var fileRequired = true;
                    var dialogButtons;
                    if (conf.type === 'none') {
                        params.push({
                            type: 'message',
                            label: 'Status',
                            paramClass: 'simple-message-param',
                            message: 'SAML Login is turned off'
                        });
                    } else {
                        params.push({
                            type: 'message',
                            label: 'Status',
                            paramClass: 'simple-message-param',
                            message: 'SAML Login is active'
                        });
                        if (conf.idp_entity_id) {
                            params.push({
                                type: 'message',
                                label: 'Identity Provider',
                                labelClass: 'no-top-padding',
                                paramClass: 'message-param-no-margin bold-text',
                                message: conf.idp_entity_id
                            });
                        }
                        if (conf.type === 'metadata') {
                            fileRequired = false;
                            defaultAction = 'upload';
                        } else {
                            defaultAction = 'set_url';
                        }
                        dialogButtons = [{
                                label: 'Disable',
                                tooltip: 'Disable SAML Login and remove configuration',
                                'type': 'close',
                                closeParams: { _buttonReset: true }
                            }];    // actions.unshift({
                                   //     value: 'reset',
                                   //     label: 'Turn off SAML and remove configuration'
                                   // });
                                   // actions.unshift({
                                   //     value: 'keep',
                                   //     label: 'Keep existing configuration'
                                   // });
                    }
                    params.push({
                        id: 'action',
                        type: 'radio-group',
                        emptyLabel: true,
                        validation: { required: true },
                        buttons: actions,
                        data: defaultAction
                    });
                    params.push({
                        id: 'metadata_url',
                        type: 'string',
                        label: 'Metadata URL',
                        data: conf.metadata_url,
                        enabled: {
                            param: 'action',
                            in: [
                                'set_url',
                                'set_from_url'
                            ]
                        },
                        validation: { required: true }
                    });
                    params.push({
                        id: 'metadata_data',
                        type: 'text',
                        label: 'Metadata',
                        data: conf.metadata_data,
                        enabled: {
                            param: 'action',
                            in: ['set_text']
                        },
                        validation: { required: true },
                        paramClass: 'full-width-param',
                        labelClass: 'text-align-left full-width-label'
                    });
                    params.push({
                        id: 'metadata_file',
                        type: 'file',
                        label: 'Select a file with metadata',
                        validation: fileRequired ? { required: { message: 'Please select file' } } : undefined,
                        enabled: [{
                                param: 'action',
                                in: ['upload']
                            }]
                    });
                    if (conf.filename && conf.type === 'metadata') {
                        params.push({
                            type: 'message',
                            emptyLabel: true,
                            labelClass: 'no-top-padding',
                            paramClass: 'message-param-no-margin',
                            message: 'File ' + '#' + JSON.stringify({
                                display: 'text',
                                text: conf.filename,
                                'class': 'bold-text'
                            }) + ' is active now',
                            enabled: [{
                                    param: 'action',
                                    in: ['upload']
                                }]
                        });
                    }
                    params.push({
                        id: 'only_existing',
                        type: 'radio-group',
                        emptyLabel: true,
                        buttons: [
                            {
                                value: false,
                                label: 'Allow login for all users authorized by the Identity Provider'
                            },
                            {
                                value: true,
                                label: '#' + JSON.stringify({
                                    display: 'text',
                                    text: 'Allow only users added to the console',
                                    tooltip: 'Allow SSO login only for users listed under \'User management\''
                                })
                            }
                        ],
                        enabled: [{
                                param: 'action',
                                in: [
                                    'upload',
                                    'set_text',
                                    'keep',
                                    'set_url',
                                    'set_from_url'
                                ]
                            }],
                        data: conf.only_existing || false
                    });
                    params.push({
                        id: 'run_azure_ad',
                        type: 'boolean',
                        emptyLabel: true,
                        rightLabel: 'Are you running Azure AD?',
                        event: 'show-azure-ad-entityid',
                        data: conf.run_azure_ad || false
                    });
                    params.push({
                        id: 'saml_azure_idp_entity_name',
                        type: 'string',
                        label: 'Azure AD entityId',
                        labelTip: 'The name you\'ve used under "Add your own application"',
                        event: 'show-azure-ad-entityid',
                        hideAsDefault: !conf.run_azure_ad,
                        data: conf.saml_azure_idp_entity_name || ''
                    });
                    return modals.params([{
                            lastPage: true,
                            okButton: 'Save',
                            params: params,
                            buttons: dialogButtons
                        }], 'Configure SAML', undefined, {
                        onCloseAction: function (params) {
                            if (params._buttonReset) {
                                params = { action: 'reset' };
                            } else {
                                if (params.only_existing === false) {
                                    delete params.only_existing;
                                }
                                if (params.action === 'upload' && conf.type === 'metadata' && !params.metadata_file) {
                                    delete params.metadata_file;
                                    params.action = 'keep';
                                }
                            }
                            return configDao.saveSamlConfig(params);
                        },
                        onCloseActionError: function (response) {
                            var message = response && response.data && response.data.message || 'Unknown error occurred';
                            modals.alert(message, { title: 'Error' });
                        }
                    });
                });
            };
        }
        function removeError(message) {
            return modals.alert(message || 'Unknown error removing custom logo', { title: 'Error' });
        }
        if (sideMenuManager.currentUser().view_private_data) {
            $scope.showDownloadConfirmationParam = true;
        }
        if ($scope.entityDebugEnabled) {
            $scope.sendEmailReport = function () {
                emailReportDao.trigger('office365-weekly').then(function () {
                    modals.alert('Report will be send in few minutes');
                });
            };
            if (!feature.checkpointTheme) {
                $scope.deletePortal = function () {
                    return modals.confirm({
                        message: 'Are you sure you want to DELETE the portal?',
                        title: 'WARNING!',
                        okText: 'Delete'
                    }).then(function () {
                        return http.put('/api/v1/delete').then(function (data) {
                            return modals.confirm({
                                message: 'Your portal is being deleted, this action will be applied in the next couple of minutes.',
                                title: 'Portal deleted',
                                okText: 'Ok'
                            });
                        });
                    });
                };
            }
            objectTypeDao.retrieve().then(function (response) {
                $scope.entityDebugPanel = {
                    title: 'Entity Debug',
                    'class': {
                        'light': true,
                        'white-body': true,
                        'white-header': true,
                        'no-margin': true
                    },
                    bodyStyle: { 'min-height': '500px' },
                    'logic': { 'name': 'debugEntityLogic' },
                    objectTypes: response
                };
            });
            $scope.debugLinksPanel = {
                title: 'Debug links',
                'class': 'light white-body white-header no-margin',
                bodyStyle: { height: '380px' },
                links: [
                    '#' + JSON.stringify({
                        display: 'link',
                        type: 'sec-app-stats',
                        text: 'Security applications statistics'
                    }),
                    '#' + JSON.stringify({
                        display: 'link',
                        type: 'main-queue-stats',
                        text: 'Main queue statistics'
                    }),
                    '#' + JSON.stringify({
                        display: 'link',
                        type: 'download-history',
                        text: 'Download history'
                    }),
                    '#' + JSON.stringify({
                        display: 'link',
                        type: 'entity-trend',
                        text: 'Entity trend'
                    }),
                    '#' + JSON.stringify({
                        display: 'link',
                        type: 'entity-per-user',
                        text: 'Entity per user'
                    }),
                    '#' + JSON.stringify({
                        display: 'link',
                        type: 'scan-monitor',
                        text: 'Scan monitor'
                    }),
                    '#' + JSON.stringify({
                        display: 'link',
                        type: 'licenses',
                        text: 'Licenses'
                    }),
                    '#' + JSON.stringify({
                        display: 'link',
                        type: 'health-check',
                        text: 'Health Check'
                    }),
                    '#' + JSON.stringify({
                        display: 'link',
                        type: 'learning-mode-state',
                        text: 'Learning Mode State'
                    })
                ]
            };
            if (feature.guiV2) {
                var jsonArr = [
                    '#' + JSON.stringify({
                        display: 'link',
                        type: 'policy-list',
                        text: 'Policies list'
                    }),
                    '#' + JSON.stringify({
                        display: 'link',
                        type: 'security-stack',
                        text: 'Security stack'
                    }),
                    '#' + JSON.stringify({
                        display: 'link',
                        type: 'sec-tool-exceptions',
                        text: 'Security Tools Exceptions'
                    })
                ];
                if (feature.sonicwallTheme) {
                    jsonArr.push('#' + JSON.stringify({
                        display: 'link',
                        type: 'ap-avanan-exceptions',
                        text: 'Anti-phishing Exceptions'
                    }));
                } else {
                    jsonArr.push('#' + JSON.stringify({
                        display: 'link',
                        type: 'ap-avanan-exceptions',
                        text: 'Anti-Phishing Allow-List'
                    }));
                }
                jsonArr.push('#' + JSON.stringify({
                    display: 'link',
                    type: 'solgate-exceptions',
                    text: 'Solgate Exceptions'
                }));
                $scope.debugLinksPanel.links = $scope.debugLinksPanel.links.concat(jsonArr);
            }
            if (modulesManager.isActive('office365_emails')) {
                $scope.debugLinksPanel.links.push('#' + JSON.stringify({
                    display: 'link',
                    type: 'inline-debug',
                    module: 'office365_emails',
                    text: 'Office365 Inline Emergency Management'
                }));
                $scope.debugLinksPanel.links.push('#' + JSON.stringify({
                    display: 'link',
                    type: 'inline-messages',
                    module: 'office365_emails',
                    text: 'Office365 Inline Messages'
                }));
                $scope.debugLinksPanel.links.push('#' + JSON.stringify({
                    display: 'link',
                    type: 'viewer',
                    module: 'office365_emails',
                    id: 'top-email-owners',
                    text: 'Office365 Email Top Email Owners'
                }));
                $scope.debugLinksPanel.links.push('#' + JSON.stringify({
                    display: 'link',
                    type: 'viewer',
                    module: 'office365_emails',
                    id: 'top-senders',
                    text: 'Office365 Email Top Senders'
                }));
                $scope.debugLinksPanel.links.push('#' + JSON.stringify({
                    display: 'link',
                    type: 'viewer',
                    module: 'office365_emails',
                    id: 'suspicious-subjects',
                    qs: { phishing: 'suspicious' },
                    text: 'Office365 Email Suspicious Subjects'
                }));
                $scope.debugLinksPanel.links.push('#' + JSON.stringify({
                    display: 'link',
                    type: 'viewer',
                    module: 'office365_emails',
                    id: 'suspicious-subjects',
                    qs: { phishing: 'phishing' },
                    text: 'Office365 Email Phishing Subjects'
                }));
            }
            if (modulesManager.isActive('google_mail')) {
                $scope.debugLinksPanel.links.push('#' + JSON.stringify({
                    display: 'link',
                    type: 'inline-messages',
                    module: 'google_mail',
                    text: 'Gmail Inline Messages'
                }));
                $scope.debugLinksPanel.links.push('#' + JSON.stringify({
                    display: 'link',
                    type: 'viewer',
                    module: 'google_mail',
                    id: 'top-email-owners',
                    text: 'GMail Top Email Owners'
                }));
                $scope.debugLinksPanel.links.push('#' + JSON.stringify({
                    display: 'link',
                    type: 'viewer',
                    module: 'google_mail',
                    id: 'top-senders',
                    text: 'Gmail Top Senders'
                }));
                $scope.debugLinksPanel.links.push('#' + JSON.stringify({
                    display: 'link',
                    type: 'viewer',
                    module: 'google_mail',
                    id: 'suspicious-subjects',
                    qs: { phishing: 'suspicious' },
                    text: 'Gmail Suspicious Subjects'
                }));
                $scope.debugLinksPanel.links.push('#' + JSON.stringify({
                    display: 'link',
                    type: 'viewer',
                    module: 'google_mail',
                    id: 'suspicious-subjects',
                    qs: { phishing: 'phishing' },
                    text: 'Gmail Phishing Subjects'
                }));
            }
            if (feature.hardReset) {
                $scope.showHardReset = true;
                $scope.performHardReset = function () {
                    return modals.confirm('Are you sure you want to reset all the data?').then(function () {
                        return commonDao.hardReset();
                    }).then(function () {
                        var deferred = $q.defer();
                        modals.widget({
                            panel: {
                                'type': 'info',
                                'class': 'hard-reset-status-dialog',
                                'wrapper': {
                                    'type': 'widget-panel',
                                    'title': 'Resetting...',
                                    'class': 'avanan white-body overflow-auto'
                                },
                                lines: [
                                    {
                                        text: 'Performing hard reset. Please wait...',
                                        'class': 'text-align-center'
                                    },
                                    {
                                        text: '',
                                        icon: 'fa-spinner fa-pulse fa-3x',
                                        'class': 'text-align-center',
                                        'style': { 'margin': '50px' }
                                    }
                                ]
                            },
                            keyboard: false,
                            backdrop: 'static',
                            noDialogButtons: true
                        });
                        function checkModules() {
                            modulesDao.cloudAppsDashboard().then(function (response) {
                                var activeSaas = _(response.data.saas).find(function (saas) {
                                    return saas.isSaas && saas.state === 'active';
                                });
                                if (!activeSaas) {
                                    routeHelper.redirectTo('dashboard');
                                } else {
                                    $timeout(checkModules, 10000);
                                }
                            });
                        }
                        checkModules();
                        return deferred.promise;
                    }, function (error) {
                        modals.alert('Failed to perform hard reset', { title: 'Error' });
                    });
                };
            }
        }
        $scope.configParams = [{
                id: 'matrix_full_scan_period_days',
                label: 'Matrix full scan period (days)',
                type: 'integer',
                min: 1,
                loaded: false,
                hidden: true
            }];
        $q.all(_($scope.configParams).chain().map(function (param) {
            if (param.hidden) {
                return false;
            }
            return configDao.param(param.id).then(function (value) {
                if (param.type === 'integer') {
                    value = parseInt(value);
                }
                param.data = value;
                param.loaded = true;
            });
        }).compact().value());
        $scope.saveConfigParam = function (param) {
            return configDao.setParam(param.id, param.data).then(function () {
                if (param.onSave) {
                    param.onSave();
                }
            });
        };
        $scope.params = { idleTimeout: idleManager.timeout() };
        $scope.saveIdleTimeout = function () {
            idleManager.timeout(parseInt($scope.params.idleTimeout));
        };
        if (feature.checkpointTheme) {
            $scope.paramsForCP = ['disable_kaspersky'];
            $scope.modelForCP = {
                disable_kaspersky: {
                    label: 'Disable Kaspersky',
                    tooltip: 'Disable Kaspersky engine when scanning for malware',
                    trueTip: 'Enable alternate/US DHS compliant AV Engine',
                    falseTip: 'Disable Kaspersky engine when scanning for malware'
                }
            };
            $scope.saveConfigForCP = function () {
                var query = [];
                var body = {};
                _($scope.paramsForCP).each(function (param) {
                    if ($scope.modelForCP[param].original !== $scope.modelForCP[param].value) {
                        body[param] = $scope.modelForCP[param].value;
                        query.push(modulesDao.saveConfig('checkpoint', body));
                    }
                });
                if (query.length > 0) {
                    $q.allSettled(query).then(function () {
                        modals.alert('Saved successfully!');
                    });
                }
            };
            $scope.changeTip = function (newValue, param) {
                if (newValue && param && $scope.modelForCP[param] && $scope.modelForCP[param].trueTip) {
                    $scope.modelForCP[param].tooltip = $scope.modelForCP[param].trueTip;
                } else {
                    if (param && $scope.modelForCP[param] && $scope.modelForCP[param].falseTip) {
                        $scope.modelForCP[param].tooltip = $scope.modelForCP[param].falseTip;
                    }
                }
            };
            _($scope.paramsForCP).each(function (param) {
                modulesDao.retrieveConfig('checkpoint', param).then(function (res) {
                    var newVal = res.data[param] && res.data[param].value;
                    if (newVal === null) {
                        newVal = !!newVal;
                    }
                    $scope.modelForCP[param].original = newVal;
                    $scope.modelForCP[param].value = newVal;
                });
            });
        }
    }]);
}());